import http from '@/http';
import requestUrlFunction from '@/utils/requestUrl';

export default {
  namespaced: true,
  actions: {
    async searchPrinters(context, params) {
      const response = await http.get(`printer/customer/${requestUrlFunction(params)}`);

      return response;
    },
    async getPrinter(context, { code, serialNumber }) {
      const response = await http.get(`printer/customer/${serialNumber}?code=${code}`);

      return response;
    },
  },
};
